import { Flex, Text, Tooltip } from "@/atoms"
import { CopyButton } from "@/molecules/CopyButton"

import styles from "./ValueCell.module.scss"

import type { DefaultRecord } from "../TableDetailsAdr"

export const ValueCell = (
  value: (record: DefaultRecord) => React.ReactNode | string,
  record: DefaultRecord
) => {
  const isFunction = typeof value === "function"
  const currentValue = isFunction ? value(record) : value
  const showCopyButton = !isFunction && !!currentValue

  return (
    <Flex align="center" justify="space-between" gap={24}>
      <Flex align="center" gap={4} flex={1} className={styles.textMono}>
        {currentValue ?? "n/a"}
        {showCopyButton && (
          <CopyButton text={value} type="link" className={styles.copyButton} />
        )}
      </Flex>

      {record.why && (
        <Tooltip title={record.why}>
          <Text underline className={styles.textTooltip}>
            Why it matters
          </Text>
        </Tooltip>
      )}
    </Flex>
  )
}
